import { motion } from 'framer-motion';
import { IoIosArrowDown } from 'react-icons/io';
import NavBar from '../../../shared/NavBar';

export default function HeroCollage() {
  return (
    <section id="home" className="relative h-screen overflow-hidden bg-black">
      <NavBar />

      {/* Imagen desktop (md+) */}
      <motion.img
        src="/images/hero/desktop.webp"
        alt="Academia Larghetto — músicos y bailarines en escena"
        className="hidden md:block absolute top-16 inset-x-0 bottom-0 w-full h-[calc(100%-4rem)] object-cover object-[center_20%]"
        initial={{ scale: 1.06, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
      />

      {/* Imagen mobile */}
      <motion.img
        src="/images/hero/mobile.webp"
        alt="Academia Larghetto — músicos y bailarines en escena"
        className="block md:hidden absolute top-16 inset-x-0 bottom-0 w-full h-[calc(100%-4rem)] object-cover object-top"
        initial={{ scale: 1.06, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
      />

      {/* Overlay degradado */}
      <div className="absolute top-16 inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20" />

      {/* Contenido */}
      <div className="relative z-10 h-full flex flex-col items-center justify-end pb-28 px-4 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="text-5xl sm:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight mb-3"
        >
          Que tu historia
        </motion.h1>

        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          className="text-5xl sm:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight mb-10"
        >
          empiece aquí.
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 items-center"
        >
          <a
            href="https://wa.me/5576737753?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20mi%20clase%20gratis%20en%20Larghetto."
            target="_blank"
            rel="noreferrer"
            className="inline-block px-8 py-4 text-black font-bold rounded-full text-sm tracking-widest uppercase hover:brightness-110 hover:scale-105 transition-all duration-300"
            style={{ background: 'linear-gradient(135deg, #FFE033, #FFB800)' }}
          >
            Clase Gratis
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/40"
      >
        <span className="text-xs tracking-widest uppercase">Baja para conocer más</span>
        <IoIosArrowDown className="animate-bounce" />
      </motion.div>

    </section>
  );
}
